import React, { useRef, useEffect, useState } from "react";
import { Card, Button, Select, Modal, Input } from "../../../../../common";
import { geoNames } from "../../../../../../utils/countriesGeonames";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { fetchStates } from "../../../../../../utils/Helper";
import { useSelector } from "react-redux";
import { getCitiesByCountryCodeAndStateName, getCountryCode, getStatesByCountryCode, extractCountryCodeAndPhoneCode } from "../../../../../../utils/countriesState";


export const AddRelatedForm = ({
  title,
  onSearch,
  selectedCompany,
  selectedCompanyName,
  showForm,
  handleRelatedSubmit,
  isLoading,
  editRelatedEntities,
  type,
  from,
  dataChanged,
  setDataChanged
}) => {
  const companyName = useRef();
  const companyType = useRef();
  const [states, setStates] = useState([]);
  const [isLoadingState, setisLoadingState] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [countries, setCountries] = useState(getCountryCode());
  const [RelationType, setRelationType] = useState(editRelatedEntities?.relation_type || "");
  const [isApiLpading, setIsApiLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    selectedCompany?.country || selectedCompany?.country_code || ""
  );
  const [errors, setErrors] = useState({
    name: "",
    relation: "",
    state: "",
    country: ""
  })
  const [isError, setIsError] = useState(false)

  const { currentEditingCompany } = useSelector((state) => state.company);

  useEffect(() => {
    if (editRelatedEntities) {
      companyName.current.value = selectedCompanyName || editRelatedEntities?.registered_company_name || "";
      setSelectedCountry(editRelatedEntities?.country);
      const selectedCountryData = countries.find(
        (country) => country.countryCode === editRelatedEntities?.country
      );

      if (selectedCountryData) {
        let statesFn = async () => {
          setisLoadingState(true);
          const states = await getStatesByCountryCode(selectedCountryData?.countryCode)
          if (states) {
            setisLoadingState(false);
          }
          setStates(states);
          setSelectedState(editRelatedEntities?.state);
        };
        statesFn();
      }
    }
  }, [editRelatedEntities]);

  useEffect(() => {
    if (selectedCompany) {
      companyName.current.value = selectedCompany?.registered_company_name || editRelatedEntities?.registered_company_name || selectedCompany?.name;
      const selectedCountryData = countries.find(
        (country) => country.countryCode === (selectedCompany?.country || selectedCompany?.country_code)
      );
      if (selectedCountryData) {
        let statesFn = async () => {
          setisLoadingState(true);
          const states = await getStatesByCountryCode(selectedCountryData?.countryCode)
          if (states) {
            setisLoadingState(false);
          }
          setStates(states);
          setSelectedState(selectedCompany.state);
        };
        statesFn();
      }
    }
  }, [selectedCompany]);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);

    const selectedCountryData = countries.find(
      (country) => country.countryCode === e.target.value
    );

    if (selectedCountryData) {
      let statesFn = async () => {
        setisLoadingState(true);
        const states = await getStatesByCountryCode(selectedCountryData?.countryCode)
        if (states) {
          setisLoadingState(false);
        }
        setStates(states);
      };
      statesFn();
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
  };
  const handlebusRel = (e) => {
    const relation_type = e.target.value;
    setRelationType(relation_type);
  };
  const goToSearch = () => {
    onSearch();
    showForm();
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();    
    setIsApiLoading(true);
    const entitydata = {
      relation_type: RelationType ?? "",
      country: selectedCountry ?? "",
      state: selectedState ?? "",
      name: (selectedCompanyName || selectedCompany.name || companyName.current.value) ?? "",
      wb_win: (selectedCompany?.win || selectedCompany?.wb_win) ?? "",
      trevex_id: selectedCompany?.companyID || ""
    };
    const newErrors = {
      relation: entitydata.relation_type === "" ? "Please specify type" : "",
      country: entitydata.country === "" ? "Please select country" : "",
      state: entitydata.state === "" ? "Please specify state" : "",
      name: entitydata.name === "" ? "Please specify type" : ""
    };
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((error) => error !== "");
    if (!hasErrors) {
      handleRelatedSubmit(entitydata);
    }
    setIsApiLoading(false)
  };


  return (
    <Card classes="rounded bg-white p-4 w-[34rem]">
      <h5 className="text-f18 text-secondarytwo text-left mb-4">{title}</h5>

      <div className="">
        <label
          htmlFor="name"
          className="block mb-1 text-primary text-f14 font-semibold text-left"
        >
          Business
        </label>
        {!selectedCompany && (
          <Button
            onClick={goToSearch}
            classes={`w-full text-left border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 block `}
          >
            Search Business
          </Button>
        )}
        <input
          label="Business Name"
          id="name"
          ref={companyName}
          placeholder="Search Business"
          className={`w-full border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${selectedCompany ? "block" : "hidden"
            }`}
          disabled={Boolean(companyName)}

        />
        {errors.name !== "" && (
          <p className="text-red-500 text-sm text-left mt-[-10px]">
            {errors.name}
          </p>
        )}
        <div className="mb-4 w-full">
          <label
            htmlFor="type"
            className="block mb-1 text-primary text-f14 font-semibold text-left"
          >
            Relation Type
          </label>

          {from === 'businessRelation' ?
            <Select
              id="type"
              value={RelationType}
              onChange={handlebusRel}
              className={`w-full border  focus:border-primary px-3 py-2 border-input rounded bg-inputDisable outline-none text-primary`}
            >
              <option value="">Select a Relation Type</option>
              <option value="customer">Customer</option>
              <option value="service_provider">Service Provider</option>
              <option value="sub_contractor">Sub Contractor</option>
              <option value="supplier">Supplier</option>
            </Select> : <Select
              id="type"
              value={RelationType}
              onChange={handlebusRel}
              className={`w-full border  focus:border-primary px-3 py-2 border-input rounded bg-inputDisable outline-none text-primary`}
            >
              <option value="">Select a Relation Type</option>
              <option value="affiliate">Affiliate</option>
              <option value="branch">Branch</option>
              <option value="branch_(of_a_foreign_entity)">Branch (of a Foreign Entity)</option>
              <option value="corporate_office">Corporate Office</option>
              <option value="holding_company">Holding Business</option>
              <option value="parent_company">Parent Business</option>
              <option value="sister_company">Sister Business</option>
              <option value="subsidiary">Subsidiary</option>
            </Select>
          }
          {errors.relation !== "" && (
            <p className="text-red-500 text-sm text-left mt-[-10px]">
              {errors.relation}
            </p>
          )}
        </div>
        <div className="mb-4 w-full">
          {isLoadingState ? <Spinner /> :
            states?.length > 0 ? <Select
              label="State"
              id="state"
              value={selectedState}
              onChange={handleStateChange}
              placeholder="Select a state"
            >
              <option value="">Select a state</option>
              {states?.map((state) => (
                <option key={state.state_code} value={state.name}>
                  {state.name}
                </option>
              ))}
            </Select> : <Input
              label="State"
              id="state"
              inputvalue={selectedState}
              onInputChange={handleStateChange}
              placeholder="Enter a state"
              disable={!selectedCountry}
              className={!selectedCountry ? "cursor-not-allowed" : "default"}
            />}
          {errors.state !== "" && (
            <p className="text-red-500 text-sm text-left mt-[-10px]">
              {errors.state}
            </p>
          )}
        </div>
        <div className="mb-4 w-full">
          <Select
            label="Country"
            id="country"
            value={selectedCountry}
            placeholder="Select a country"
            onChange={handleCountryChange}
            disable={true}
          >
            <option value="" >Select a country</option>
            {countries
              .sort((a, b) => a.countryName.localeCompare(b.countryName))
              .map((country, index) => (
                <option key={index} disabled={selectedCountry != '' ? true : false} value={country.countryCode}>
                  {country.countryName}
                </option>
              ))}
          </Select>
          {errors.country !== "" && (
            <p className="text-red-500 text-sm text-left mt-[-10px]">
              {errors.country}
            </p>
          )}
        </div>
        <button
          onClick={handleSubmit}
          disabled={selectedCompany ? false : true}
          className={`w-full p-2 text-white rounded text-f18 mt-4 flex items-center justify-center ${!selectedCompany ? "cursor-not-allowed bg-disable" : "cursor-pointer bg-primary"}`}
        >
          {isLoading || isApiLpading ? <Spinner /> : "Save"}
        </button>
      </div>
    </Card>
  );
};
